import { useMemo } from 'react';
import { compact } from 'lodash';

import { Bean, NumberPatternType, ValidationRules } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../../../../../translations';
import { TimeBasedRefundTableBean } from '../TimeBasedRefundInteractiveTable.types';

const t = serviceSettingsTranslationKeys.advancePayments.form.timeBasedRefundInteractiveTable.thresholdInHours;
const MIN = 0;
const MAX = 336;

type ThresholdInHoursCellProps = InteractiveTableCellProps<number>;

export const ThresholdInHoursCell = (props: ThresholdInHoursCellProps): JSX.Element => {
   const VALIDATION_RULES: ValidationRules<Bean> = useMemo(
      () => ({
         required: true,
         max: { value: MAX, message: t.validationMessage.max },
         min: { value: MIN, message: t.validationMessage.min },
         validate: (__, getValue) => {
            const timeBasedRefund = getValue('timeBasedRefund') as TimeBasedRefundTableBean[];
            const thresholds = compact(timeBasedRefund.map(({ thresholdInHours }) => thresholdInHours));
            const uniqueThresholds = new Set(thresholds);

            if (uniqueThresholds.size === thresholds.length) {
               return undefined;
            }

            return t.validationMessage.identicalValuesCannotOccur;
         },
      }),
      []
   );

   return (
      <InteractiveTable.NumberInputCell
         index={props.index}
         name='thresholdInHours'
         testId={'thresholdInHours'}
         min={MIN}
         max={MAX}
         pattern={NumberPatternType.POSITIVE_INTEGER}
         defaultValue={props.defaultValue}
         placeholder={t.placeholder}
         validationRules={VALIDATION_RULES}
      />
   );
};
